import React, { useEffect, useState, useRef } from "react";
import { Button } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-hot-toast";
import http from "../services/httpService";
import { prospectPath, getDateTime } from "../utils/varialbles";
import { useHistory, useRouteMatch } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },

  checked: {},
}));
function MutualfundUpload() {
  let history = useHistory();

  let [lookupFile, setLookupFile] = useState("");
  const classes = useStyles();

  const handleChange = (e) => {
    let fileObj = e.target.files[0];
  };
  const handleFileChange = (event) => {
    setLookupFile(event.target.files[0]);
  };
  const fileInputRef = useRef(null);

  const [date, setDate] = useState('');

  useEffect(() => {
    http.get('/mfupload').then(res => {
      // (res);
      setDate(res.data.data);
    }).catch(err => {

    });
  }, [])

  const uploadBulkFile = () => {
    if (lookupFile === "") {
      toast.error("Please upload the file");
    } else {
      const formData = new FormData();
      formData.append("file", lookupFile, lookupFile["name"]);
      http
        .post("/mfupload", formData)
        .then((response) => {
          if (
            response.data.data &&
            response.data.statusCode === 0 &&
            Array.isArray(response.data.data)
          ) {
            // toast.error("Mobile Number Already Exist");
          } else {
            toast.success(response.data.data);
            history.push(prospectPath);
          }
        })
        .catch((error) => {
          toast.error("Ticket Request Failed..!");
        });
    }
  };

  //   (navigator.userAgent, 'userAgent');

  //   (navigator.platform, 'platform');

  //  var el_down = 
  //   document.getElementById("GFG_DOWN");

  // const gfg_Run =() => {
  //   // var iOS = 
  //   //     /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  //   //     !window.MSStream;

  //   // el_down.innerHTML = iOS;


  //   var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   // Windows Phone must come first because its UA also contains "Android"
  //   if (/windows phone/i.test(userAgent)) {
  //       return el_down.innerHTML =  "Windows Phone";
  //   }

  //   if (/android/i.test(userAgent)) {
  //       return el_down.innerHTML = "Android";
  //   }

  //   // iOS detection from: http://stackoverflow.com/a/9039885/177710
  //   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //       return el_down.innerHTML =  "iOS";
  //   }

  // }

  return (
    <>
      <div>
        <h1>Upload your file here:</h1>
        {/* <input type="file" onChange={handleChange} /> */}

        <p><b>Last updated date:</b> {date ? getDateTime(date) : "N/A"}</p>
        {/* 
        <p id="GFG_UP"> 
      Detecting whether a device is iOS.
    </p>
    <button onClick={gfg_Run}>
        detect
    </button>
    <p id="GFG_DOWN">
    </p> */}

        <>
          <input
            ref={fileInputRef}
            onChange={handleFileChange}
            type="file"
            style={{ display: "none" }}
            multiple={false}
            accept=".xlsx, .xls, .csv"
          />
          <Button
            startIcon={<AddCircleOutlineIcon />}
            variant="outlined"
            className={classes.reviewButton}
            color="primary"
            onClick={() => fileInputRef.current.click()}
          >
            Choose File
          </Button>
          <span style={{ marginLeft: 10 }}>
            {lookupFile && lookupFile.name ? lookupFile.name : "No file chosen"}
          </span>
        </>
      </div>
      <Button
        variant="contained"
        style={{ marginTop: "10px" }}
        color="primary"
        onClick={uploadBulkFile}
      >
        Upload MF Upload
      </Button>
    </>
  );
}

export default MutualfundUpload;
